module.exports = __webpack_public_path__ + "img/nav02.140ac9ec.png";